var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyDeepDive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 14.2283,
    height: 29.9905,
    rx: 0.95,
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6523,
    y: 30.1445,
    width: 2.92575,
    height: 3.84499,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.43164,
    y: 25.1055,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0508,
    y: 25.1055,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6719,
    y: 25.1055,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.43164,
    y: 19.3555,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0508,
    y: 19.3555,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6719,
    y: 19.3555,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.43164,
    y: 13.6016,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0508,
    y: 13.6016,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6719,
    y: 13.6016,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.43164,
    y: 7.84766,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0508,
    y: 7.84766,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6719,
    y: 7.84766,
    width: 2.12195,
    height: 2.16396,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2266,
    y: 15.7578,
    width: 13.772,
    height: 18.2325,
    rx: 0.38,
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 9.75249,
    height: 1.91889,
    rx: 0.38,
    transform: "matrix(1 0 0 -1 21.2363 15.7578)",
    fill: "#E3D6C7",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3887,
    y: 18.7109,
    width: 1.34322,
    height: 3.95368,
    rx: 0.38,
    transform: "rotate(90 25.3887 18.7109)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3887,
    y: 21.6953,
    width: 1.34322,
    height: 3.95368,
    rx: 0.38,
    transform: "rotate(90 25.3887 21.6953)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3887,
    y: 24.6836,
    width: 1.34322,
    height: 3.95368,
    rx: 0.38,
    transform: "rotate(90 25.3887 24.6836)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8066,
    y: 18.7109,
    width: 1.34322,
    height: 3.95368,
    rx: 0.38,
    transform: "rotate(90 30.8066 18.7109)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8066,
    y: 21.6953,
    width: 1.34322,
    height: 3.95368,
    rx: 0.38,
    transform: "rotate(90 30.8066 21.6953)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8066,
    y: 24.6836,
    width: 1.34322,
    height: 3.95368,
    rx: 0.38,
    transform: "rotate(90 30.8066 24.6836)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4434,
    y: 27.8984,
    width: 1.5604,
    height: 3.75436,
    rx: 0.38,
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5059,
    y: 27.8984,
    width: 3.24134,
    height: 6.10068,
    rx: 0.38,
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2461,
    y: 27.8984,
    width: 1.5604,
    height: 3.75436,
    rx: 0.38,
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDeepDive);
export default __webpack_public_path__ + "static/media/companyDeepDive.c26bafd23b646f1633d5f6f4a4763cfc.svg";
export { ForwardRef as ReactComponent };